import React from "react";
import './style.scss';
import { image } from "../../Assets";

const Whatwedo = () =>{
    return(
        <section className="whatwedo">      
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h2>At Fractile, we are experts at recognizing and solving the problems that create friction for you.</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5 col-12">
                        <img src={image.whatwedo} alt="" id="construction" data-aos="fade-right" style={{zIndex:'1',position:'relative'}}/>
                    </div>
                    <div className="col-lg-7 col-12">
                        <h5>What we do</h5>
                        <h3 style={{fontWeight:'bold'}}><b>Whatever solutions your community<br/>  needs,we develop them.</b></h3>
                        <p>The AEC industry is undergoing digital transformation amid a shortage of skilled labor. At Fractile Studio, we understand the challenges of moving forward on your digital journey. 
                            We are experienced, accountable partners ready to flex our resources to your digital processing needs.</p>
                        <button className="btn-2" data-aos="fade-left" data-aos-delay="400">
                            <a href="/about" style={{textDecoration:'none'}}>Know more</a>  
                        </button>
                    </div>
                </div>
            </div>      
        </section>
    )
}
export default Whatwedo;